import { render, staticRenderFns } from "./InfosetsTableTab.vue?vue&type=template&id=238fb89f&scoped=true&"
import script from "./InfosetsTableTab.vue?vue&type=script&lang=ts&"
export * from "./InfosetsTableTab.vue?vue&type=script&lang=ts&"
import style0 from "./InfosetsTableTab.vue?vue&type=style&index=0&id=238fb89f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238fb89f",
  null
  
)

export default component.exports